(function() {
  'use strict';

angular
  .module('traineeWebApp.main')
  .controller('MainCtrl', MainCtrl);

  MainCtrl.$inject = ['$rootScope', '$scope', '$timeout', '$window', 'dashboardStoreService', 'Navigation', 'SessionExpiration'];

  function MainCtrl($rootScope, $scope, $timeout, $window, dashboardStoreService, Navigation, SessionExpiration) {
    $scope.navigation = Navigation;

    if($window.navigator.userAgent.match(/iPhone/i) != null) {
      iNoBounce.disable();
    }

    $rootScope.app = {};

    // default values that need to be set
    $scope.thumbModel = {
      thumbs: null
    };

    $scope.cModuleModel = {
      cModuleTitle: ''
    };

    // there is a bug in IE8/9 with flash where the title is replace with the hash value
    // the fix is to wait a whole second to change the title ugh
    var waitForTitle = (BrowserDetect.browser == 'Explorer' && BrowserDetect.version < 10) ? 1000 : 0;

    // gives us the ability to affect quiz styles individually via responsiveness
    $rootScope.questionStyle = '';

    var needPlaceHolderSupport = BrowserDetect.browser == 'Explorer' && BrowserDetect.version < 10;
    var placeHolderTimeout = 0;

    $rootScope.$on("initPlaceholders", initPlaceholders);

    function initPlaceholders() {
      // only need placeholder support for IE8 and IE9
      if (needPlaceHolderSupport) {
        placeHolderTimeout = setTimeout(function () {
          // ignore input that are select2 because placeholder is built in
          $('input[placeholder]:not([ui-select2])').placeholder();
          $('textarea[placeholder]').placeholder();
        }, 500);
      }
    }

    $rootScope.$on("$routeChangeStart", function (event, next) {
      if (next && next.redirectUrl) {
        //Force angular to stop controlling the browser location so we can take manual control
        $rootScope.$on('$locationChangeStart', function (e) {
          e.preventDefault();
        });

        $window.location = next.redirectUrl(next.params);
        return;
      }

      SessionExpiration.resetIdleTimer();
    });


    $scope.$on("$routeChangeSuccess", function (event, next, previous) {
      var pageName = getPageName(next);

      if (!mfConfig.hideMindflashBranding)
        pageName = pageName + ' | Trakstar Learn Training Management System';
      $timeout(function () {
        $window.document.title = pageName;
      }, waitForTitle);

      updateStoredSelectedCModule(pageName, next);
    });

    function updateStoredSelectedCModule(pageName, next) {
      if (!~pageName.toLowerCase().indexOf('module')) return;

      var cModuleId = next.params.cModuleId;
      var seriesId = next.params.seriesId;

      var selectedCModule = dashboardStoreService.read("selectedCModule");

      // TODO: should move to dashboardStoreService which is basically saying
      // do not update unless you need to ...which is kindof overkill
      if (!selectedCModule) {
        dashboardStoreService.save("selectedCModule", {
          cModuleId: cModuleId,
          seriesId: seriesId
        });
      } else {
        if (selectedCModule.seriesId && seriesId && selectedCModule.seriesId == seriesId) {
          return;
        }

        if (selectedCModule.cModuleId != cModuleId) {
          dashboardStoreService.save("selectedCModule", {
            cModuleId: cModuleId
          });
        }
      }
    }

    function getPageName(route) {
      if (!route || !route.$$route) {
        return "";
      }

      return route.$$route.pageName || "";
    }
  }
})();
